'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cssifyKeyframe;

var _cssifyObject = require('./cssifyObject');

var _cssifyObject2 = _interopRequireDefault(_cssifyObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * renders keyframes into a CSS string with all prefixes
 *
 * @param {Object} frames - validated frame declarations
 * @param {string} animationName - animation reference naming
 * @param {string[]} prefixes - list of used vendor prefixes
 * @return {string} valid CSS string
 */
function cssifyKeyframe(frames, animationName) {
  var prefixes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [''];

  var keyframe = Object.keys(frames).reduce(function (css, percentage) {
    return css + percentage + '{' + (0, _cssifyObject2.default)(frames[percentage]) + '}';
  }, '');

  return prefixes.reduce(function (css, prefix) {
    return css + '@' + prefix + 'keyframes ' + animationName + '{' + keyframe + '}';
  }, '');
} /*  weak */
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/utils/cssifyKeyframe.js
// module id = 441
// module chunks = 0